/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

import './PlaceholderLPCard.scss'

// Maps the raw category type (logic id passed by LessonPlanPage) to a full
// per-category empty-state key, so the whole sentence is translatable
// (instead of interpolating an untranslated category word).
const EMPTY_KEY_BY_TYPE = {
  finished: 'lessonPlans.placeholderCard.empty.finished',
  draft: 'lessonPlans.placeholderCard.empty.draft',
  '': 'lessonPlans.placeholderCard.empty.all',
  "'in use'": 'lessonPlans.placeholderCard.empty.inUse',
  pinned: 'lessonPlans.placeholderCard.empty.pinned',
  community: 'lessonPlans.placeholderCard.empty.community',
}

const PlaceholderLPCard = ({ type }) => {
  const { t } = useTranslation()
  const emptyKey = EMPTY_KEY_BY_TYPE[type] || 'lessonPlans.placeholderCard.empty.all'

  return (
    <div id='PlaceholderLPCard'>
      <p>{t(emptyKey)}</p>
    </div>
  )
}

export default PlaceholderLPCard
